/**
 * Determines whether an instruction is evaluated on the server side.
 * Having this encapsulated in a utility function enables mocking flag's value
 * for unit testing server-specific behavior.
 * @returns {boolean} true if called in server side context
 * @category Utils
 */
export const isServer = (): boolean => !!import.meta.server
